var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#111135",
    stroke: "#111135",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.487 20C12.743 16.856 18 11.15 18 7.477 18 3.355 14.628 0 10.487 0 6.345 0 3 3.355 3 7.477 3 11.149 8.257 16.83 10.487 20zM3.61 7.477c0-3.778 3.08-6.843 6.876-6.843 3.823 0 6.902 3.065 6.902 6.843 0 3.46-4.831 8.692-6.902 11.493C8.442 16.17 3.61 10.91 3.61 7.477zm6.876-2.827c-1.567 0-2.841 1.268-2.841 2.827s1.274 2.827 2.84 2.827c1.594 0 2.841-1.268 2.841-2.827S12.08 4.65 10.487 4.65zm0 .608c1.248 0 2.23 1.004 2.23 2.219 0 1.215-.982 2.22-2.23 2.22-1.222 0-2.23-1.005-2.23-2.22 0-1.215 1.008-2.22 2.23-2.22z",
    transform: "translate(-44 -970) translate(20 948) translate(24 22)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.2921eae519f6f11c179ce37716a4241e.svg";
export { ForwardRef as ReactComponent };